import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterNoticeDemande extends ISearchLimitOffset {
    Ean?: string | null;
    IdEtat?: number;
    LibellesTypeDemande?: string[];
    SortField?: string;
    IsDescending?:boolean;
  }

  export const getDefaultFilterNoticeDemande = (): IFilterNoticeDemande => ({
    Ean: null,
    IdEtat: undefined,
    LibellesTypeDemande: undefined,
    Offset: 0,
    Limit: 10,
    SortField: "Id",
    IsDescending: true,
  });
  
  export const filterToQuery = (filter: IFilterNoticeDemande): IFilterNoticeDemande => {
    const dto: IFilterNoticeDemande = {};
    
    if (filter?.Ean !== "" ) {
      dto.Ean = filter.Ean;
    } 

    if (filter?.IdEtat !== undefined ) {
      dto.IdEtat = filter.IdEtat;
    } 

    if (filter?.LibellesTypeDemande !== undefined ) {
      dto.LibellesTypeDemande = filter.LibellesTypeDemande;
    } 
    
   
    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }
    
    localStorage.setItem("IFilterNoticesDemandesNotices", JSON.stringify(dto));
  
    return dto;
  };
  
  export const dtoToFilter = (dto: IFilterNoticeDemande): IFilterNoticeDemande => {
  
    return {
      Ean: dto.Ean,
      IdEtat: dto.IdEtat,
      LibellesTypeDemande: dto.LibellesTypeDemande,
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
      IsDescending: dto.IsDescending !== undefined ? dto.IsDescending : false,
      SortField: dto.SortField,
    };
  };
 